import { Component } from '@angular/core';

@Component({
  selector: 'lib-data-form-grid',
  standalone: true,
  template: `
    <div class="data-form-grid">
      <ng-content />
    </div>
  `,
  styles: [`
    .data-form-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: 10px;
    }
  `],
})
export class DataFormGridComponent {}
